import { apiBaseUrl } from '_legacy/config';
import { useEffect, useState } from 'react';

const ShallowHealthPage: React.FC = () => {
    const [healthResponse, setHealthResponse] = useState('Loading...');

    useEffect(() => {
        fetch(`https://${apiBaseUrl}/health/shallow`)
            .then((response) => response.text())
            .then((response) => setHealthResponse(response))
            .catch((error) => setHealthResponse(`Error: ${error.message}`));
    }, []);

    return (
        <div style={{ whiteSpace: 'pre', font: 'Roboto', lineHeight: 1 }}>
            {healthResponse}
        </div>
    );
};

export default ShallowHealthPage;
